import home from '@/view/home_page.vue'
import browse from '@/view/browse_page.vue'
import statistics from "@/view/statistics_page.vue";
import download from "@/view/download_page.vue";
import genome_browser from "@/view/genome_browser_page.vue";
import help from '@/view/help_page.vue'
import detail from "@/view/detail_page.vue";
import search from "@/view/search_page.vue"
import TF_binding_analysis from "@/view/analysis/analysis_page.vue"
import analysis_chromatin_interaction from '@/view/analysis/analysis_chromatin_interaction.vue'
import Prediction_of_cell_marker_variations from '@/view/analysis/Prediction_of_cell_marker_variations.vue'
import TF_binding_detail from "@/view/analysis/detail/analysis1.vue"
import analysis_chromatin_interaction_detail from "@/view/analysis/detail/analysis2.vue"
import Prediction_of_cell_marker_variations_detail from "@/view/analysis/detail/analysis3.vue"
export default [
    {
        path: '/',
        component: home,
        meta:{show:true},
    },
    {
        path: '/home',
        component: home,
        meta:{show:true},
    },
    {
        path: '/browse',
        component: browse,
        meta:{show:true},
    },
    {
        path: '/statistics',
        component: statistics,
        meta:{show:true},
    },
    {
        path: '/download',
        component: download,
        meta:{show:true},
    },
    {
        path: '/genome_browser',
        component: genome_browser,
        meta:{show:true},
    },
    {
        path: '/help',
        component: help,
        meta:{show:true},
    },
    {
        path: '/detail',
        component: detail,
        meta:{show:true},
    },
    {
        path: '/search',
        component: search,
        meta:{show:true},
    },
    {
        path: '/TF_binding_analysis',
        component: TF_binding_analysis,
        meta:{show:true},
    },
    {
        path: '/TF_binding_analysis/detail',
        component: TF_binding_detail,
        meta:{show:true},
    },
    {
        path: '/analysis_chromatin_interaction',
        component: analysis_chromatin_interaction,
        meta: {show: true}
    },
    {
        path: '/analysis_chromatin_interaction/detail',
        component: analysis_chromatin_interaction_detail,
        meta: {show: true}
    },
    {
        path: '/Prediction_of_cell_marker_variations',
        component: Prediction_of_cell_marker_variations,
        meta: {show: true}
    },
    {
        path: '/Prediction_of_cell_marker_variations/detail',
        component: Prediction_of_cell_marker_variations_detail,
        meta: {show: true}
    },

]
